import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskText, Eyebrow } from "@/components/motion";
import { CtaButton } from "@/components/CtaButton";

const CHIPS = ["Tutti i protocolli viso e corpo", "Formazione continua", "Academy Natural Anti-Age"];

export const Doors = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "center center"] });
  const left = useTransform(scrollYProgress, [0, 1], ["0%", "-100%"]);
  const right = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  const glow = useTransform(scrollYProgress, [0, 1], [0.2, 1]);

  return (
    <section ref={ref} className="relative overflow-hidden border-t border-line px-5 py-28 sm:px-8 md:py-40" data-testid="doors-section">
      <motion.div style={{ opacity: glow }} className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_55%_at_50%_45%,rgba(199,154,75,0.28),transparent_70%)]" />
      <motion.div style={{ x: left }} className="pointer-events-none absolute inset-y-0 left-0 z-10 w-1/2 border-r border-gold/40 bg-gradient-to-r from-ink to-ink2" aria-hidden="true" />
      <motion.div style={{ x: right }} className="pointer-events-none absolute inset-y-0 right-0 z-10 w-1/2 border-l border-gold/40 bg-gradient-to-l from-ink to-ink2" aria-hidden="true" />
      <div className="relative mx-auto max-w-3xl text-center">
        <Eyebrow>Centri Official Partner</Eyebrow>
        <MaskText className="mt-6 text-5xl leading-[1] text-cream sm:text-6xl lg:text-7xl" lines={["Abbiamo aperto", <span className="gold-text">le porte dei</span>, <em className="gold-text">nostri segreti.</em>]} />
        <Reveal>
          <p className="lead mx-auto mt-8 max-w-2xl">Per la prima volta il Metodo Skin Lovers viene insegnato per intero, solo ai Centri Official Partner: tutti i protocolli, la formazione continua e l'ingresso nell'Academy Natural Anti-Age. Al workshop ti spieghiamo come funziona e come candidare il tuo centro.</p>
        </Reveal>
        <Reveal className="mt-8 flex flex-wrap justify-center gap-2">
          {CHIPS.map((c) => <span key={c} className="chip border-gold/30">{c}</span>)}
        </Reveal>
        <Reveal className="mt-12"><CtaButton testid="doors-cta-btn">Scopri come entrare</CtaButton></Reveal>
      </div>
    </section>
  );
};
